import * as React from "react";

function SvgBBiconsNemovitostiVlastnik(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <g data-name="Obecn\xE9 ikony">
        <path
          d="M100 24.14c-3.86 0-7 3.17-9.31 5.33l-23.88 22V41.9c0-4.46-2-8.07-4.45-8.07h-11.1c-4.44 0-4.44 3.61-4.44 8.07v27.89l-17.08 15.7v.06l-6.34 5.84c-8.27 7.46 1.34 15.59 8.51 8.82L100 37l68.05 63.19c7.17 6.77 16.78-1.36 8.51-8.82L170 85.33v-.06l-60.66-55.8c-2.35-2.16-5.42-5.33-9.28-5.33H100zm0 20.75l-68.6 63.28V164c0 6.55 6.22 11.86 13.89 11.86h14.1a13.32 13.32 0 01-.74-4.26c0-21 10.1-30.69 24.45-34.45a28.54 28.54 0 0033.82 0c14.35 3.77 24.43 13.49 24.43 34.45a13.32 13.32 0 01-.74 4.26h14c7.67 0 13.89-5.31 13.89-11.86v-55.83zm.08 45a23.87 23.87 0 11-23.88 23.88A23.89 23.89 0 01100 89.86z"
          fillRule="evenodd"
          data-name="Nemovitosti - vlastnik"
        />
      </g>
    </svg>
  );
}

export default SvgBBiconsNemovitostiVlastnik;
